import "App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Landing from "components/landing/Landing";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
